import { queryClient } from 'src/config/request';
import { contentListQueries } from 'src/modules/contentList/queries';
export class ModuleCacheUpdater {
    static updateTotalPagesAfterPageReorder(moduleId, targetModuleId, extra) {
        queryClient.setQueryData(contentListQueries.getModules({ extra }).queryKey, (oldData) => {
            return oldData?.map((module) => {
                if (module.id === targetModuleId) {
                    return { ...module, totalPages: module.totalPages + 1 };
                }
                if (module.id === moduleId) {
                    return { ...module, totalPages: Math.max(module.totalPages - 1, 0) };
                }
                return module;
            });
        });
    }
}
